import styled from '@emotion/styled';

// The facilitator's panel pieces shared by the alternative runs and the outcome runs (#1062).
export const Box = styled.div`
  display: flex; flex-direction: column; gap: 10px; padding-top: 6px;
  h4 { margin: 0; font-size: 13px; font-weight: 600; color: rgba(255,255,255,0.75); text-transform: uppercase; letter-spacing: 0.06em; }
`;
export const Frame = styled.div`
  border: 1px solid #2c3444; border-radius: 8px; padding: 10px 12px; display: flex; flex-direction: column; gap: 8px;
  strong { font-size: 14px; }
  small { color: rgba(255,255,255,0.55); }
`;
export const Row = styled.div`display: flex; flex-wrap: wrap; gap: 8px; align-items: center;`;
export const Button = styled.button`
  all: unset; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 12px; border-radius: 8px; font-size: 13px; font-weight: 600;
  color: rgba(255,255,255,0.85); border: 1px solid #2c3444;
  &:disabled { opacity: 0.45; cursor: default; }
`;
export const Muted = styled.p`margin: 0; color: rgba(255,255,255,0.55); font-size: 13px; line-height: 1.5;`;
export const ErrorBox = styled.p`
  margin: 0; padding: 8px 12px; border-radius: 8px; font-size: 13px;
  border: 1px solid rgba(255,107,107,0.5); background: rgba(255,107,107,0.12); color: #ffd9d9;
`;
